import { css } from "@emotion/css";

import { white } from "@/modules/theme/utils/colors";
import { Theme } from "@/modules/theme/utils/createTheme";
import { fade } from "@/modules/theme/utils/fade";

export const createUserMenuStyles = ({
  typography,
  spacing,
  zIndexes,
}: Theme) => {
  return {
    root: css({
      display: "flex",
      padding: spacing([2, 3, 1]),
      width: "100%",
      position: "sticky",
      top: 0,
      zIndex: zIndexes.topbar,
      backgroundColor: fade(white, 0.9),

      "@supports ((-webkit-backdrop-filter: none) or (backdrop-filter: none))": {
        backdropFilter: "blur(20px)",
        backgroundColor: fade(white, 0.8),
      },
    }),
    contentWrapper: css({
      marginLeft: spacing(2),
      width: "100%",
      minWidth: 0,
    }),
    firstDataRow: css({
      width: "100%",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
    }),
    title: css({
      fontSize: typography.pxToRem(20),
      flexGrow: 1,
      whiteSpace: "nowrap",
      overflowX: "hidden",
      textOverflow: "ellipsis",
      marginRight: spacing(2),
    }),
    avatar: css({
      flexShrink: 0,
    }),
  };
};
